<div class="efile-add-edit-page">

  <!-- ============================================================ -->
  <!-- LEFT PANE: Entity hierarchy (legacy SubmissionController)     -->
  <!-- ============================================================ -->
  <!-- When submission shell menu is open, collapse entity rail (chevron stays to close it). -->
  <aside class="entity-pane" [class.collapsed]="!showHierarchy || submissionShellMenuOpen">
    <div class="entity-pane-header">
      <button type="button" class="hierarchy-toggle" (click)="toggleSubmissionShellMenu()"
              [title]="submissionShellMenuOpen ? 'Hide submission menu' : 'Show submission menu (switch tabs)'">
        <i class="fa" [class.fa-chevron-right]="submissionShellMenuOpen" [class.fa-chevron-left]="!submissionShellMenuOpen"></i>
      </button>
      @if (showHierarchy && !submissionShellMenuOpen) {
<div class="entity-header-search">
        <i class="fa fa-search entity-header-search-icon" aria-hidden="true"></i>
        <input type="text"
               [(ngModel)]="searchTerm"
               (ngModelChange)="filterTreeData()"
               placeholder="Search entities..."
               class="form-control input-sm entity-header-search-input"
               aria-label="Search entities">
      </div>
}
    </div>

    @if (showHierarchy && !submissionShellMenuOpen) {
<div class="entity-pane-body">

      @if (loadingKeys) {
<div class="entity-loader">
        <i class="fa fa-spinner fa-spin"></i> Loading hierarchy...
      </div>
}

      @if (!loadingKeys && entityTree.length > 0) {
<ul class="entity-tree">
        @for (node of entityTree; track trackByKey($index, node)) {
<li
            class="entity-node"
            [class.is-folder]="node.IS_LEAF === 0"
            [class.is-leaf]="node.IS_LEAF === 1"
            [class.is-active]="node.active"
            [hidden]="node.hidden"
            [style.padding-left.px]="(node.LVL || 0) * 14">
          <span class="entity-row" (click)="entitySelected(node)">
            <i class="fa entity-icon"
               [ngClass]="{
                 'fa-folder-open': node.IS_LEAF === 0 && !node.childrenHidden,
                 'fa-folder': node.IS_LEAF === 0 && node.childrenHidden,
                 'fa-file-pdf-o': node.IS_LEAF === 1,
                 'color-orange': (node.LVL || 0) > 0
               }"></i>
            <span class="entity-label" [title]="node.KEY_DESC">{{ node.KEY_DESC }}</span>
          </span>
        </li>
}
      </ul>
}

      @if (!loadingKeys && entityTree.length === 0) {
<div class="entity-empty">
        No entities found for this submission.
      </div>
}
    </div>
}
  </aside>

  <!--
    Data/PDF/Overrides/XML tab strip + body: sibling of entity aside so the
    hierarchy is outside the data tab pane (not indented under the rail).
  -->
  <gtw-efile-elements-data
    class="efile-data-rail-column"
    [activeTab]="activeTab"
    (tabChange)="onDataShellTabChange($event)">

  <!-- ============================================================ -->
  <!-- RIGHT PANE: Form tiles → editor                              -->
  <!-- ============================================================ -->
  <main class="form-pane">

    <!--
      Banners — direct port of legacy `addEdit.html` L491-L494:
        <div class="highlighted-text" ng-if="IS_LOCKED || SUBMISSION_STATUS === PRODUCTION_ACCEPTED">
          <span ng-if="IS_LOCKED">The Submission is Locked.</span>
          <span ng-if="SUBMISSION_STATUS === PRODUCTION_ACCEPTED">The Submission is Production Accepted.</span>
        </div>
      Both spans render inside the same strip when both flags are truthy
      (legacy parity). The per-form `lockEdit` banner is kept as a
      separate info-row because it was added in migration and never had a
      legacy banner — legacy hid the Save button alone for that case.
    -->
    @if (isSubmissionLocked || isProductionAccepted) {
<div class="banner banner-warning highlighted-text"
        >
      <i class="fa fa-exclamation-triangle"></i>
      @if (isSubmissionLocked) {
<span>{{ SUBMISSION_LOCKED_MESSAGE }} </span>
}
      @if (isProductionAccepted) {
<span>{{ PROD_ACCEPTED_MESSAGE }}</span>
}
    </div>
}
    <!--
      Lock-edit banner is gated on `showData && selectedForm` so it
      cannot persist after the user switches entity nodes (entitySelected
      now resets `lockEdit` + `showData` + `selectedForm`, but this
      template guard is the second line of defence in case any future
      caller flips `lockEdit=true` while the editor is closed). Without
      this gate the migrated banner survived after an entity change
      because `lockEdit` lived independently of the editor visibility
      state, contrary to the legacy parity where the warning was wired
      to the active form pane only.
    -->
    @if (lockEdit && showData && selectedForm && !isProductionAccepted && !isSubmissionLocked) {
<div class="banner banner-info"
        >
      <i class="fa fa-lock"></i>
      {{ LOCK_EDIT_MESSAGE }}
    </div>
}

    <!--
      Empty state matches legacy `addEdit.html` ("Please select the entity.")
      shown by ui-router when `data.addEdit` first activates with no entity
      pre-selected in the hierarchy tree.
    -->
    @if (!selectedEntity && !showData) {
<div class="form-empty-state form-empty-state--entity"
        >
      <i class="fa fa-arrow-left"></i>
      Please select the entity.
    </div>
}

    @if ((selectedEntity || keyIdFromRow) || showData) {
<div class="form-pane-scroll"
        >
    <!--
      Tile-list ↔ form-editor split. Legacy parity:
        - Legacy `data.html` (ui/app/components/efile/efileElements/data.html
          L36-L66) rendered `.icons-list` and `.content-view` as siblings
          inside a `.tab-container` flex row. The tile list was ALWAYS in the
          DOM; when the form editor opened (`ctrl.showData = true`), the
          tile list got `.collapsed` (`width: 220px`, two 100px tiles per
          row) and the content view flex-grew next to it with vertical
          scroll on its own.
        - Previously the migrated shell was hiding the tile grid via
          `*ngIf="!showData"` once the editor opened, which broke parity:
          users could no longer pick a different form from the tile list
          without backing out of the editor.

      The wrapper switches from `flex-direction: column` (tiles only) to
      `row` (tiles + editor) via the `.with-editor` modifier, mirroring the
      legacy `.tab-container` swap.
    -->
    <div class="form-pane-body" [class.with-editor]="showData">
    <!-- Form-tile grid (legacy DATA tiles) -->
    @if (selectedEntity || keyIdFromRow) {
<section class="tile-grid-section"
            
             [class.collapsed]="showData"
             [class.closed]="showData && expandView">
      <!-- Legacy `addEdit.html` L445–450: `.card-header.form-card` (+ and search). -->
      <div class="tile-grid-header form-card">
        <div class="tile-grid-toolbar">
          @if (shouldShowToolbarAdd()) {
<i
            class="fa fa-plus fa-2x add-form-btn"
           
            (click)="startAddForm()"
            title="Add form"
            role="button"
            tabindex="0"
            (keyup.enter)="startAddForm()"></i>
}
          @if (shouldShowToolbarSearch()) {
<div class="tile-grid-search search-container">
            <i class="fa fa-search search-icon" aria-hidden="true"></i>
            <input
              type="text"
              class="search form-control input-sm"
              [(ngModel)]="formSearchTxt"
              (ngModelChange)="onFormSearchInput()"
              placeholder="Search forms"
              aria-label="Search forms"
            />
          </div>
}
        </div>
      </div>

      <div class="tile-grid-scroll">
      @if (loadingForms) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin"></i> Loading forms...
      </div>
}

      @if (!loadingForms && filteredUniqForms.length > 0) {
<div class="tile-grid"
          >
        @for (form of filteredUniqForms; track trackByForm($index, form)) {
<div class="form-tile"
            
             [class.is-active]="form.isActive"
             [class.unsaved]="form.unsaved"
             (click)="selectForm(form)"
             [title]="form.FORM">
          <svg xmlns="http://www.w3.org/2000/svg"
               class="form-tile-icon"
               width="48.015"
               height="52"
               viewBox="0 0 48.015 52"
               style="align-self: center;">
            <g id="DATA-980" transform="translate(-89.485 -110.5)">
              <g id="Group_1" data-name="Group 1" transform="translate(-64.515 77.5)">
                <g id="Group_1-2" data-name="Group 1" transform="translate(154 33)">
                  <path id="Path_3" data-name="Path 3" d="M-38.656,195h-31.87A4.478,4.478,0,0,1-75,190.527V147.473A4.478,4.478,0,0,1-70.526,143h31.871a4.478,4.478,0,0,1,4.473,4.473v43.053A4.478,4.478,0,0,1-38.656,195Zm-7.269-10.624a.559.559,0,0,0-.553.553v3.915a.559.559,0,0,0,.553.553H-38.1a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm-12.3,0a.559.559,0,0,0-.559.553v3.915a.559.559,0,0,0,.559.553H-50.4a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm-12.3,0a.559.559,0,0,0-.553.553v3.915a.559.559,0,0,0,.553.553H-62.7a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm24.6-8.947a.559.559,0,0,0-.553.553V179.9a.559.559,0,0,0,.553.553H-38.1a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm-12.3,0a.559.559,0,0,0-.559.553V179.9a.559.559,0,0,0,.559.553H-50.4a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm-12.3,0a.559.559,0,0,0-.553.553V179.9a.559.559,0,0,0,.553.553H-62.7a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm24.6-8.947a.559.559,0,0,0-.553.553v3.915a.559.559,0,0,0,.553.553H-38.1a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm-12.3,0a.559.559,0,0,0-.559.553v3.915a.559.559,0,0,0,.559.553H-50.4a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm-12.3,0a.559.559,0,0,0-.553.553v3.915a.559.559,0,0,0,.553.553H-62.7a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm24.6-8.947a.559.559,0,0,0-.553.553V162a.559.559,0,0,0,.553.553H-38.1a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm-12.3,0a.559.559,0,0,0-.559.553V162a.559.559,0,0,0,.559.553H-50.4a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm-12.3,0a.559.559,0,0,0-.553.553V162a.559.559,0,0,0,.553.553H-62.7a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm24.6-8.947a.559.559,0,0,0-.553.552v3.915a.559.559,0,0,0,.553.553H-38.1a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm-12.3,0a.559.559,0,0,0-.559.553v3.915a.559.559,0,0,0,.559.553H-50.4a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Zm-12.3,0a.559.559,0,0,0-.553.552v3.915a.559.559,0,0,0,.553.553H-62.7a.559.559,0,0,0,.553-.553v-3.915a.559.559,0,0,0-.553-.553Z" transform="translate(82.197 -143)" fill="#dddcdf"></path>
                  <path id="Path_1" data-name="Path 1" d="M116.267-13h30.957l6.92,6.723V7.2H116.267Z" transform="translate(-116.267 26.664)" fill="#e45f0f"></path>
                  <path id="Path_2" data-name="Path 2" d="M8.828-9.542a6.216,6.216,0,0,1-.3,1.988A4.723,4.723,0,0,1,7.669-6,3.826,3.826,0,0,1,6.35-4.984a4.014,4.014,0,0,1-1.716.361H1.46V-14.46H4.627A3.982,3.982,0,0,1,6.35-14.1a3.882,3.882,0,0,1,1.326,1.014,4.683,4.683,0,0,1,.855,1.555,6.216,6.216,0,0,1,.3,1.989Zm-1.577,0A5.3,5.3,0,0,0,7.067-11a3.263,3.263,0,0,0-.522-1.09,2.294,2.294,0,0,0-.829-.691,2.446,2.446,0,0,0-1.093-.238H3.015v6.93H4.627A2.446,2.446,0,0,0,5.72-6.321a2.294,2.294,0,0,0,.829-.691A3.263,3.263,0,0,0,7.071-8.1a5.3,5.3,0,0,0,.178-1.441ZM17.671-4.621H16.478a.467.467,0,0,1-.33-.119.68.68,0,0,1-.186-.3l-.62-2.008H11.9l-.619,2.013a.648.648,0,0,1-.181.286.459.459,0,0,1-.33.13h-1.2l3.259-9.845H14.41ZM12.3-8.334h2.645l-1.01-3.274q-.069-.218-.152-.514t-.163-.644q-.08.347-.157.646t-.152.524Zm11.86-6.126v1.5h-2.5v8.339H20.12v-8.339H17.612v-1.5Zm8.061,9.843H31.027a.467.467,0,0,1-.33-.119.68.68,0,0,1-.186-.3l-.62-2.008H26.455l-.62,2.008a.648.648,0,0,1-.181.286.459.459,0,0,1-.33.13h-1.2l3.259-9.843h1.579ZM26.85-8.334H29.5l-1.01-3.274q-.069-.218-.152-.514t-.163-.644q-.08.347-.157.646t-.152.524Z" transform="translate(1.854 34.028)" fill="#fff"></path>
                </g>
              </g>
            </g>
          </svg>
          <div class="form-tile-label">{{ form.FORM || form.form }}</div>
        </div>
}
      </div>
}

      @if (!loadingForms && filteredUniqForms.length === 0) {
<div class="form-empty-state"
          >
        No forms available for this entity.
      </div>
}
      </div>
      <!-- /.tile-grid-scroll -->
    </section>
}

    <!-- ========================================================= -->
    <!-- Form editor (right-pane drilldown after a tile is clicked) -->
    <!-- ========================================================= -->
    @if (showData) {
<section class="form-editor-section">
      <!--
        Full-pane "Saving.." overlay — direct port of the legacy
        `addEdit.html` L497-L502 `.loader-overlay` markup. Painted on top
        of the entire editor while `saving` is true so the user cannot
        keep typing/clicking while the rv8nq0 round-trip is in flight.
      -->
      @if (saving) {
<div class="add-edit-loader-overlay" aria-live="polite">
        <div class="add-edit-loader-overlay-inner">
          <i class="fa fa-spinner fa-spin fa-4x"></i>
          <div class="add-edit-loader-overlay-text">Saving..</div>
        </div>
      </div>
}

      <div class="filter-bar legacy-filter-bar">
        <div class="filter-strip">
          <div class="legacy-filter-ta-cell">
            <gtw-efile-typeahead-select
              class="legacy-filter-select"
              [ngModel]="selectedForm"
              (ngModelChange)="onTypeaheadFormChange($event)"
              (selectionChange)="onTypeaheadFormSelected($event)"
              [options]="formOptionsForEditor"
              displayKey="FORM"
              [maxResults]="0"
              placeholder="Select a Form"
              [appendToBody]="true"
            ></gtw-efile-typeahead-select>
          </div>
          <span class="bread-crumb-sep">/</span>

          <div class="legacy-filter-ta-cell">
            <gtw-efile-typeahead-select
              class="legacy-filter-select"
              [ngModel]="selectedFormSub"
              (ngModelChange)="onTypeaheadFormSubChange($event)"
              [options]="formSubOptions"
              displayKey="FORM_SUB"
              [maxResults]="30"
              placeholder="Select a Form Sub"
              [loading]="loadingSubs"
              [appendToBody]="true"
            ></gtw-efile-typeahead-select>
          </div>
          <span class="bread-crumb-sep">/</span>

          <div class="legacy-filter-ta-cell">
            <gtw-efile-typeahead-select
              class="legacy-filter-select"
              [ngModel]="selectedParentElement"
              (ngModelChange)="onTypeaheadParentElementChange($event)"
              [options]="parentElementNames"
              displayKey="PARENT_ELEMENT_NAME"
              [maxResults]="30"
              placeholder="Select a parent element name"
              [loading]="loadingParentElems"
              [appendToBody]="true"
            ></gtw-efile-typeahead-select>
          </div>
        </div>

        <div class="filter-actions legacy-filter-actions">
          <button class="btn btn-primary btn-sm action-btn"
                  (click)="showForm()"
                  [disabled]="!selectedForm || !selectedFormSub || !selectedParentElement">
            Show Form
          </button>
          <!--
            Save / Unlock visibility — direct port of legacy
            addEdit.html L560-L564:
              ng-if="!(SUBMISSION_STATUS === PRODUCTION_ACCEPTED || IS_LOCKED)"
              ng-show="!lockEdit"  (Save)  /  ng-show="lockEdit"  (Unlock)
            Both buttons are hidden whenever the submission is Production
            Accepted OR submission-level IS_LOCKED — only View remains.
          -->
          @if (!lockEdit && !isProductionAccepted && !isSubmissionLocked) {
<button class="btn btn-primary btn-sm action-btn"
                  (click)="save()"
                 
                  [disabled]="saving || changedFields.length === 0">
            @if (saving) {
<span><i class="fa fa-spinner fa-spin"></i></span>
} Save
          </button>
}
          @if (lockEdit && !isProductionAccepted && !isSubmissionLocked) {
<button class="btn btn-primary btn-sm action-btn"
                 
                  (click)="unlockForm()"
                  [disabled]="saving">
            Unlock
          </button>
}
          <button class="btn btn-primary btn-sm action-btn"
                  (click)="viewStyleSheet()"
                  [disabled]="loadingStylesheet || !formId">
            @if (loadingStylesheet) {
<span><i class="fa fa-spinner fa-spin"></i></span>
} View
          </button>
        </div>
      </div>

      <div class="tree-container">
        @if (loadingTree) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin"></i> Loading form data...
        </div>
}

        @if (!loadingTree && formTree.length > 0) {
<div class="form-tree">
          @for (row of formTree; track trackByTreeRow($index, row)) {


            <!-- Intermediate header row (non-repeating dotted segment) -->
            @if (row.kind === 'header') {
<div
                 class="form-tree-row form-tree-header"
                 [style.padding-left.px]="(row.level - 1) * 14">
              <i class="fa fa-caret-down"></i>
              <!--
                Schema tooltip — native browser `title` attribute renders
                the multi-line key/value summary built by
                `schemaTooltipText` (legacy `uib-tooltip-html` parity at
                addEdit.html L585-L590, simplified to plain text).
              -->
              <span class="form-tree-header-name"
                    [attr.title]="schemaTooltipText(row)">
                @if (row.isRequired) {
<span class="req-asterisk">*</span>
}
                {{ row.ELEMENTNAME }}
              </span>
            </div>
}

            <!--
              Leaf row (single editable field) — line / element / sno / field
              cell shape ports the legacy `.data-row` (addEdit.html L577-L605).
              The element name is wrapped in `<span class="element-name">` so
              the dotted leader line rendered via `.element::after` is masked
              behind the name (see legacy `.element:after` L317-L324). Without
              that opaque-background wrapper, the dots would bleed through the
              text glyphs.
            -->
            @if (row.kind === 'leaf') {
<div
                 class="form-tree-row form-tree-leaf"
                 [class.changed]="row.IS_CHANGED === 'Y'"
                 [class.is-required]="row.isRequired"
                 [style.padding-left.px]="(row.level - 1) * 14">
              <div class="line" [attr.title]="lineColumnTooltip(row)">{{ row.LINENO || '' }}</div>
              <div class="element">
                @if (row.isRequired) {
<span class="req-asterisk">*</span>
}
                <!-- Schema tooltip — see Site 1 comment above. -->
                <span class="element-name" [attr.title]="schemaTooltipText(row)">
                  {{ row.ELEMENTNAME }}
                </span>
              </div>
              <div class="sno">{{ row.SNO || '' }}</div>
              <div class="field field-with-validation">
                @if (showLeafValidationHint(row)) {
<i
                   class="fa fa-info-circle validation-hint-icon"
                   [attr.title]="row.VALIDATIONEXPLANATION || 'Invalid value'"
                   aria-hidden="true"></i>
}
                <div class="field-input-wrap">
                  @if (isEnumField(row)) {
<select
                          class="form-control input-sm"
                          [class.data-form-field-invalid]="showLeafValidationHint(row)"
                          [ngModel]="row.ELEMENTVALUE || ''"
                          (ngModelChange)="onFieldChange(row, $event)"
                          (blur)="onLeafValidationBlur(row)"
                          [disabled]="!isFieldEditable(row)">
                    @for (opt of row.ENUMVALUES; track $index) {
<option [value]="opt">{{ opt }}</option>
}
                  </select>
}
                  @if (!isEnumField(row)) {
<input
                         type="text"
                         class="form-control input-sm"
                         [class.data-form-field-invalid]="showLeafValidationHint(row)"
                         [ngModel]="row.ELEMENTVALUE || ''"
                         (ngModelChange)="onFieldChange(row, $event)"
                         (blur)="onLeafValidationBlur(row)"
                         [maxlength]="row.MAXLENGTH || null"
                         [disabled]="!isFieldEditable(row)">
}
                </div>
              </div>
            </div>
}

            <!--
              Repeated-data sub-table — matches the legacy `addEdit.html`
              layout (ui/app/components/efile/efileElements/data/addEdit.html
              L580-L658). Each table-typed `dataRow` paints:
                1. A title row mirroring the line / element / sno / field
                   cell shape of leaf rows, with the table name + an
                   inline `fa-plus-square` add-row icon inside the
                   `.element` cell — there is no separate "Add row" button
                   below the table in the legacy UI.
                2. The table itself (light-gray header per legacy
                   `.table-container th`, NOT the dark header the migrated
                   shell was rendering before).
                3. An inline `fa-minus-square` delete icon next to the SNO
                   value in each row's first cell — also matching legacy.
                   No separate right-side action column.
                4. A "Showing 1 to N of N" pagination footer below the
                   table (legacy L657).
            -->
            @if (row.kind === 'table') {
<div class="form-tree-table-wrap"
                 [style.padding-left.px]="(row.level - 1) * 14">
              <div class="form-tree-row form-tree-table-title-row"
                   [class.is-required]="row.isRequired">
                <div class="line" [attr.title]="lineColumnTooltip(row)">{{ row.LINENO || '' }}</div>
                <div class="element">
                  @if (row.isRequired) {
<span class="req-asterisk">*</span>
}
                  <!-- Schema tooltip — see Site 1 comment above. -->
                  <span class="element-name" [attr.title]="schemaTooltipText(row)">
                    {{ row.ELEMENTNAME }}
                  </span>
                  <!--
                    Disable the `+` add-row icon when the table has hit
                    its `MAX_OCCURS` cap. Legacy `addRepeatedData`
                    (EfileElementsController.js L2395-L2397) had the cap
                    check commented out; migration enforces it so the UI
                    stays consistent with the "Max records allowed: N"
                    label rendered alongside the table.
                  -->
                  <i class="fa fa-plus-square inline-add-icon"
                     [class.disabled]="!canAddRepeatedRow(row)"
                     [attr.title]="canAddRepeatedRow(row) ? 'Add row' : 'Maximum records reached'"
                     (click)="canAddRepeatedRow(row) && addRepeatedRow(row)"></i>
                </div>
                <div class="sno"></div>
                <div class="field"></div>
              </div>

              <!--
                Dynamic max-height — direct port of legacy `addEdit.html`
                L606-L608: tables with >5 visible rows are clamped at
                200px and become scrollable; smaller tables get
                (rows*20 + 75)px so they grow with their content. The
                wrapper itself is `overflow-y: auto` (see SCSS) and the
                `<thead>` already sticks to the top via `position: sticky`.
              -->
              @if (row.tableHeaders && row.tableHeaders.length > 0) {
<div class="form-tree-table"
                  
                   [style.maxHeight.px]="repeatedTableMaxHeightPx(row)">
                <table class="table table-condensed custom-table">
                  <thead>
                    <tr>
                      <th class="sno-col">SNO</th>
                      <!--
                        Column-header tooltip — native browser `title`
                        attribute carrying the multi-line schema summary
                        from `schemaTooltipText` (port of legacy
                        `uib-tooltip-html` at addEdit.html L617-L623,
                        simplified to plain text).
                      -->
                      @for (h of row.tableHeaders; track trackByHeader($index, h)) {
<th
                          class="repeated-data-header"
                          [class.is-required]="h.isRequired"
                          [attr.title]="schemaTooltipText(h)">
                        @if (h.isRequired) {
<span class="req-asterisk">*</span>
}
                        {{ h.nodeName }}
                      </th>
}
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Legacy L630: `ng-show="!repData.toDelete"` — deleted rows are not listed; no restore icon. -->
                    @for (r of visibleRepeatedRows(row); track trackBySno($index, r)) {
<tr
                        [class.row-new]="r.isNew">
                      <td class="sno-col">
                        <span class="sno-value">{{ r.SNO }}</span>
                        <i class="fa fa-minus-square sno-delete-icon"
                           [class.disabled]="isReadOnly"
                           (click)="!(isReadOnly) && toggleDeleteRow(row, r)"></i>
                      </td>
                      @for (h of row.tableHeaders; track trackByHeader($index, h)) {
<td
                          [class.changed]="getRepeatedCell(r, h)?.IS_CHANGED === 'Y'"
                          [class.nested-cell]="h.isNested || h.parentNodeName">
                        <!--
                          Icon must not depend on `getRepeatedCell`: sparse rows can
                          lack a cell until lazy host creation; legacy still shows the
                          expander when `repHeadBody.parentNodeName` is set.
                        -->
                        @if (showRepeatedExpanderIcon(getRepeatedCell(r, h), h)) {
<i
                           class="fa fa-external-link row-expander"
                           [class.row-expander--disabled]="isReadOnly"
                           role="button"
                           tabindex="0"
                           [attr.aria-label]="'Open nested editor for ' + h.nodeName"
                           (click)="!(isReadOnly) && openNestedGridByHeader(r, h, row)"
                           (keyup.enter)="!(isReadOnly) && openNestedGridByHeader(r, h, row)"></i>
}

                        @if (getRepeatedCell(r, h); as cell) {

                          @if (showRepeatedScalarEditor(cell, h)) {

                            <div class="scalar-field-with-validation">
                              @if (showRepeatedValidationHint(r, cell)) {
<i
                                 class="fa fa-info-circle validation-hint-icon"
                                 [attr.title]="cell.VALIDATIONEXPLANATION || 'Invalid value'"
                                 aria-hidden="true"></i>
}
                              <div class="scalar-field-input-wrap">
                                @if (isEnumField(cell)) {
<select
                                        class="form-control input-sm"
                                        [class.data-form-field-invalid]="showRepeatedValidationHint(r, cell)"
                                        [ngModel]="cell.ELEMENTVALUE || ''"
                                        (ngModelChange)="onRepeatedCellChange(r, cell, $event)"
                                        (blur)="onRepeatedValidationBlur(r, cell)"
                                        [disabled]="!isFieldEditable(cell) || !!r.toDelete">
                                  @for (opt of cell.ENUMVALUES; track $index) {
<option [value]="opt">{{ opt }}</option>
}
                                </select>
}
                                @if (!isEnumField(cell)) {
<input
                                       type="text"
                                       class="form-control input-sm"
                                       [class.data-form-field-invalid]="showRepeatedValidationHint(r, cell)"
                                       [ngModel]="cell.ELEMENTVALUE || ''"
                                       (ngModelChange)="onRepeatedCellChange(r, cell, $event)"
                                       (blur)="onRepeatedValidationBlur(r, cell)"
                                       [maxlength]="cell.MAXLENGTH || null"
                                       [disabled]="!isFieldEditable(cell) || !!r.toDelete">
}
                              </div>
                            </div>
                          
}
                        
}
                        @if (!getRepeatedCell(r, h) && !showRepeatedExpanderIcon(null, h)) {
<span class="empty-cell"></span>
}
                      </td>
}
                    </tr>
}
                  </tbody>
                </table>
              </div>
}

              @if (row.tableHeaders && row.tableHeaders.length > 0 && repeatedTablePaginationText(row)) {
<div class="form-tree-table-pagination"
                  >
                <p>{{ repeatedTablePaginationText(row) }}</p>
              </div>
}

              @if (!row.tableHeaders || row.tableHeaders.length === 0) {
<div class="form-tree-table-empty"
                  >
                No repeated rows.
              </div>
}
            </div>
}

          
}
        </div>
}

        <!-- <div *ngIf="!loadingTree && formTree.length === 0 && selectedForm"
             class="form-empty-state">
          No data found for this form/sub/parent-element combination.
        </div> -->
      </div>
    </section>
}
    </div>
    <!-- /.form-pane-body -->
    </div>
}
    <!-- /.form-pane-scroll -->

    <!-- Pre-save comments — same shell as overlay; body/footer from gtw-efile-comments-modal -->
    @if (showCommentsModal) {
<div class="comments-modal-overlay" (click)="onCancelCommentsModal()">
      <div class="comments-modal-backdrop"></div>
      <div
        class="comments-modal-dialog comments-modal-dialog--embed"
        role="dialog"
        aria-modal="true"
        (click)="$event.stopPropagation()"
      >
        <!--
          Legacy parity (`comments-modal-tpl.html` L13-L17): the textarea
          is `ng-model="ctrl.comment"` and the Save button is
          `ng-disabled="!ctrl.comment"` — i.e. the comment is mandatory
          before askComment can finish and call vm.saveForm. Set
          `[allowEmptySubmit]="false"` so the shared `gtw-efile-comments-modal`
          mirrors that gate; otherwise users could press Save with an
          empty textarea and bypass the legacy guard.
        -->
        <gtw-efile-comments-modal
          [modalTitle]="'Add a comment'"
          [allowEmptySubmit]="false"
          [showCharCount]="true"
          [maxCommentLength]="500"
          (request-grid-update)="onCommentsModalRequest($event)"
        ></gtw-efile-comments-modal>
      </div>
    </div>
}

    <!-- ============================================================ -->
    <!-- Inner-grid popup — port of addOrOpenChildRow (L2343) and       -->
    <!-- legacy add-edit-inner-grid.html. Edits flow into the same      -->
    <!-- changedFields collection, so the outer Save picks them up.     -->
    <!-- ============================================================ -->
    @if (nestedPopup; as np) {

      <div class="nested-grid-overlay">
        <div class="nested-grid-backdrop" (click)="closeNestedGrid()"></div>
        <div class="nested-grid-dialog" role="dialog" aria-modal="true">
          <!--
            Legacy add-edit-inner-grid.html L426-L430:
              <div class="modal-header">
                <h4>
                  {{ctrl.popUpTitle}}
                  <i class="fa fa-times pull-right hoverable" ng-click="$close()"></i>
                </h4>
              </div>
            Header chrome (orange `#c25423` background + white text) ports the
            global `.modal-header` rule (styles.scss L17-L37) that all other
            migrated dialogs share, so the nested grid blends with the rest
            of the migrated UI.
          -->
          <div class="nested-grid-header modal-header">
            <h4>
              {{ np.title }}
              <i class="fa fa-times pull-right hoverable nested-grid-header-close"
                 (click)="closeNestedGrid()"
                 role="button"
                 tabindex="0"
                 (keyup.enter)="closeNestedGrid()"
                 aria-label="Close"></i>
            </h4>
          </div>
          <!--
            Legacy `add-edit-inner-grid.html` L432-L470 nests the table
            inside `.modal-body.gt-dashboard-ex-body` →
            `.data-row-container` → `.data-row` → `.table-container` →
            `<form name="innerGridForm">` → `<table style="max-width: 1300px">`.
            The wrapper hierarchy keeps the horizontal scroll on
            `.table-container` (not the whole modal body) so the
            sticky-thead and `repeated-data-header.is-required` highlight
            stay aligned with the legacy CSS.
          -->
          <div class="nested-grid-body modal-body gt-dashboard-ex-body">
            <div class="data-row-container">
              <div class="data-row">
                <div class="table-container">
                  <!-- Legacy add-edit-inner-grid.html L437. -->
                  @if (nestedMaxOccursDisplay(np.nestedTable); as maxOcc) {
<label class="inner-grid-max-occurs"
                        >
                    Max records allowed: <span>{{ maxOcc }}</span>
                  </label>
}
                  <!--
                    Empty-state when no headers could be derived from
                    sibling rows OR from `treeData` (suffix fallback).
                    Without this, a misaligned `s3hr77` payload left the
                    modal showing only chrome and the close button, with
                    no indication of why the table body was missing.
                  -->
                  @if (np.nestedTable.tableHeaders.length === 0) {
<div class="form-empty-state form-empty-state--inner-grid"
                      >
                    <i class="fa fa-exclamation-triangle"></i>
                    No editable columns are available for this group.
                  </div>
}
                  @if (np.nestedTable.tableHeaders.length > 0) {
<form class="nested-grid-form"
                       
                        (submit)="$event.preventDefault()">
                    <!--
                      Dynamic max-height for the inner-grid table — same
                      legacy formula as the outer grid (addEdit.html
                      L606-L608) so nested tables with >5 rows scroll
                      inside the popup instead of growing past the
                      visible viewport.
                    -->
                    <div class="form-tree-table"
                         [style.maxHeight.px]="repeatedTableMaxHeightPx(np.nestedTable)">
                      <table class="table table-bordered table-condensed custom-table">
                        <thead>
                          <tr>
                            @if (nestedTableShowSnoAddColumn(np.nestedTable)) {
<th class="sno-col">
                              SNO
                              <!-- Same MAX_OCCURS cap enforcement as the outer-grid + icon. -->
                              <i class="fa fa-plus-square inline-add-icon"
                                 [class.disabled]="!canAddRepeatedRow(np.nestedTable)"
                                 [attr.title]="canAddRepeatedRow(np.nestedTable) ? 'Add row' : 'Maximum records reached'"
                                 (click)="canAddRepeatedRow(np.nestedTable) && addRepeatedRow(np.nestedTable)"></i>
                            </th>
}
                            @for (h of np.nestedTable.tableHeaders; track trackByHeader($index, h)) {
<th
                                class="repeated-data-header"
                                [class.is-required]="h.isRequired"
                                [attr.title]="schemaTooltipText(h)">
                              @if (h.isRequired) {
<span class="req-asterisk">*</span>
}
                              {{ h.nodeName }}
                            </th>
}
                          </tr>
                        </thead>
                        <tbody>
                          <!-- Legacy L674: `ng-show="!subRepHead.toDelete"` — no restore control. -->
                          @for (r of visibleNestedRows(np.nestedTable); track trackBySno($index, r)) {
<tr
                              [class.row-new]="r.isNew">
                            @if (r.IS_REPEATED) {
<td class="sno-col sno-col--inner">
                              <span class="sno-value">{{ r.SNO }}</span>
                              <i class="fa fa-minus-square sno-delete-icon"
                                 [class.disabled]="isReadOnly"
                                 (click)="!(isReadOnly) && toggleDeleteRow(np.nestedTable, r)"></i>
                            </td>
}
                            @for (h of np.nestedTable.tableHeaders; track trackByHeader($index, h)) {
<td
                                [class.changed]="getRepeatedCell(r, h)?.IS_CHANGED === 'Y'">
                              @if (showRepeatedExpanderIcon(getRepeatedCell(r, h), h)) {
<i
                                 class="fa fa-external-link row-expander"
                                 [class.row-expander--disabled]="isReadOnly"
                                 role="button"
                                 tabindex="0"
                                 [attr.aria-label]="'Open nested editor for ' + h.nodeName"
                                 (click)="!(isReadOnly) && openNestedGridByHeader(r, h, undefined, np.nestedTable)"
                                 (keyup.enter)="!(isReadOnly) && openNestedGridByHeader(r, h, undefined, np.nestedTable)"></i>
}
                              @if (getRepeatedCell(r, h); as cell) {

                                @if (showRepeatedScalarEditor(cell, h)) {
<div class="scalar-field-with-validation">
                                  @if (showRepeatedValidationHint(r, cell)) {
<i
                                     class="fa fa-info-circle validation-hint-icon"
                                     [attr.title]="cell.VALIDATIONEXPLANATION || 'Invalid value'"
                                     aria-hidden="true"></i>
}
                                  <div class="scalar-field-input-wrap">
                                    <!--
                                      Legacy `add-edit-inner-grid.html` L456/L459 binds
                                      `ng-required="::repHeadBody.isRequired"` on the
                                      inner-grid input/select so required columns get
                                      the HTML5 invalid styling. Mirror that with
                                      `[attr.required]` driven by the column header's
                                      `isRequired` flag — set it to '' (present) when
                                      the column is required, otherwise null so the
                                      attribute is removed entirely.
                                    -->
                                    @if (isEnumField(cell)) {
<select
                                            class="form-control input-sm"
                                            [class.data-form-field-invalid]="showRepeatedValidationHint(r, cell)"
                                            [attr.required]="h.isRequired ? '' : null"
                                            [ngModel]="cell.ELEMENTVALUE || ''"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="onRepeatedCellChangeByHeader(r, h, $event)"
                                            (blur)="onRepeatedValidationBlur(r, cell)"
                                            [disabled]="!isFieldEditable(cell) || !!r.toDelete">
                                      @for (opt of cell.ENUMVALUES; track $index) {
<option [value]="opt">{{ opt }}</option>
}
                                    </select>
}
                                    @if (!isEnumField(cell)) {
<input
                                           type="text"
                                           class="form-control input-sm"
                                           [class.data-form-field-invalid]="showRepeatedValidationHint(r, cell)"
                                           [attr.required]="h.isRequired ? '' : null"
                                           [ngModel]="cell.ELEMENTVALUE || ''"
                                           [ngModelOptions]="{standalone: true}"
                                           (ngModelChange)="onRepeatedCellChangeByHeader(r, h, $event)"
                                           (blur)="onRepeatedValidationBlur(r, cell)"
                                           [maxlength]="cell.MAXLENGTH || null"
                                           [disabled]="!isFieldEditable(cell) || !!r.toDelete">
}
                                  </div>
                                </div>
}
                              
}
                              <!--
                                Legacy empty cell: disabled input when no model and
                                not a parentNodeName (popup-only) column.
                              -->
                              @if (!getRepeatedCell(r, h) && !showRepeatedExpanderIcon(null, h)) {
<input
                                     type="text"
                                     class="form-control input-sm"
                                     value=""
                                     disabled>
}
                            </td>
}
                          </tr>
}
                        </tbody>
                      </table>
                    </div>
                  </form>
}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
}

  </main>
  </gtw-efile-elements-data>
</div>
